<template>
  <ui-component-modal
    modalTitle="Reservations in set"
    :onClickCancel="onClickCancel"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <table class="table is-fullwidth is-striped is-hoverable">
        <tbody>
          <tr
            v-for="set in reservation.ReservationSetIds"
            :key="set.Id"
            :class="{ 'is-selected': set.Id === reservation.Id }"
          >
            <td>#{{ set.Id }}</td>
            <td>{{ set.Date | dateObjectIsoDateString }}</td>
            <td class="has-text-right">
              <a href="">
                <span class="icon is-small has-text-danger">
                  <font-awesome-icon :icon="['fas', 'times']" />
                </span>
                Remove from set
              </a>
            </td>
            <td class="has-text-right">
              <a
                @click="goToReservation(set.Id)"
                class="has-margin-left"
                :class="{
                  'is-loading': isLoading && selectedReservationId === set.Id,
                }"
                v-if="set.Id != reservation.Id"
              >
                <span class="icon is-small">
                  <font-awesome-icon :icon="['fas', 'share']" />
                </span>
                Open
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </ui-component-modal>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import reservationProvider from '@/providers/reservation'

export default {
  components: {},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      selectedReservationId: 0,
    }
  },

  computed: {
    ...mapState('reservationStore', ['reservation']),
  },

  created() {},

  methods: {
    ...mapMutations('reservationStore', ['setReservation']),

    setItemClicked(reservationId) {
      this.setReservation(null)
      this.goToReservation(reservationId)
    },

    goToReservation(reservationId) {
      //window.location.reload(true)

      this.$router
        .push({
          name: `reservations-list-detail`,
          params: { reservationId: reservationId },
        })
        .catch((err) => {})

      this.onClickCancel()
    },
  },
}
</script>
